import http from '../../../utils/fetch';
export default {

    selectPage(query) {
        return http({
            url: '/api/swyl/v1/loudnew/loudMain/selectPage',
            method: 'post',
            params: query
        });
    },

    deleteTarget(query) {
        return http({
            url: '/api/swyl/v1/loudnew/loudMain/deleteList',
            method: 'post',
            data: query
        });
    },

    saveOrUpdate(query) {
        return http({
            url: '/api/swyl/v1/loudnew/loudMain/saveOrUpdate',
            method: 'post',
            data: query
        });
    },


    newSaveOrUpdate(query) {
        return http({
            url: '/api/swyl/v1/loudnew/loudMain/newSaveAndUpdate',
            method: 'post',
            data: query
        });
    },
    submitContent(query) {
        return http({
            url: '/api/swyl/v1/demo/loudMainContent/submitContent',
            method: 'post',
            data: query
        });
    },
    contentPass(query) {
        return http({
            url: '/api/swyl/v1/demo/loudMainContent/contentPass',
            method: 'post',
            data: query
        });
    },
    getLdContentByMainId(query) {
        return http({
            url: '/api/swyl/v1/demo/loudMainContent/getLdContentByMainId',
            method: 'post',
            data: query
        });
    },

    getLoudById(query){
        return http({
            url: '/api/swyl/v1/loudnew/loudMain/selectById?funnelId=' + query,
            method: 'post',
        });
    },
    getLoudByIdXs(query){
        return http({
            url: '/api/swyl/v1/loudnew/loudMain/selectByIdXs?funnelId=' + query,
            method: 'post',
        });
    },
    getLoudByTaskIdXt(query){
        return http({
            url: '/api/swyl/v1/loudnew/loudMain/getLoudByTaskIdXt?taskid=' + query,
            method: 'post',
        });
    },
    selectByFunCode(query){
        return http({
            url: '/api/swyl/v1/loudnew/loudMain/selectByFunCode?funcode=' + query,
            method: 'post',
        });
    },
    getLoudMainByInstId(query){
        return http({
            url: '/api/swyl/v1/loudnew/loudMain/getLoudMainByInstId?instId=' + query,
            method: 'post',
        });
    },

    loudPsaa(query) {
        return http({
            url: '/api/swyl/v1/loudnew/loudMain/loudPsaa',
            method: 'post',
            data: query
        });
    },
    isqianyueloudPsaa(query){
        return http({
            url: '/api/swyl/v1/loudnew/loudMain/isqianyueloudPsaa',
            method: 'post',
            data: query
        });
    },



    loudList(query) {
        return http({
            url: '/api/swyl/v1/loudnew/loudMain/loudList',
            method: 'post',
            data: query
        });
    },
    selectSalesmans(query){
        return http({
            url: '/api/swyl/v1/loudnew/loudMain/selectSalesmans',
            method: 'post',
            data: query
        });
    },
    selectSalesmanLikeName(query){
        return http({
            url: '/api/swyl/v1/demo/bscUserDayCleanConfig/findUserNamesLike?userName='+query,
            method: 'get',
            data: query
        });
    },
    batchRepairSalesman(query){
        return http({
            url: '/api/swyl/v1/loudnew/loudMain/batchRepairSalesman',
            method: 'post',
            data: query
        });
    },
    isAgentOrderLoud(query){
        return http({
            url: '/api/swyl/v1/loudnew/loudMain/isAgentOrderLoud',
            method: 'post',
            data: query
        });
    },

    //根据漏斗信息获取对应产品
    updateprostatus(data){
        return http({
            url: '/api/swyl/v1/loudnew/loudMain/updateprostatus',
            method: 'post',
            data: data
        })
    },
    // 根据经销商 获取渠道
    getChanl(query) {
        return http({
            url: '/api/swyl/v1/loudnew/loudMain/getChanl?usercode='+query,
            method: 'post',
        });
    },
    //根据漏斗信息跳转查详情
    selectByFunnelIdXs(query) {
        return http({
            url: '/api/swyl/v1/loudnew/loudMain/selectByFunnelIdXs?funnelId='+query,
            method: 'post',
        });
    },
    //判断是否申请过特价跳转页面
    toUrl(query,type){
        return http({
            url: '/api/swyl/v1/loudnew/loudMain/selectByFunnelIdTj?id=' + query +'&type=' + type,
            method: 'post'
        })
    }
}
